(function(){
var N=window.JNR_NEWS||[];if(!N.length)return;
var B=window.JNR_B16||null;
function $(s,r){return (r||document).querySelector(s)}
function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
function money(c){return (c/100).toFixed(2).replace('.',',')+' €'}
function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
var m=location.pathname.match(/\/products\/([^\/?#]+)/);
var cur=m?m[1]:'';
function isNew(h){return N.some(function(n){return n.handle===h})}
var minPrice=Math.min.apply(null,N.map(function(n){return n.price}));

/* ---- Fiches produit : promo 16K + bandeau nouveautés ---- */
var pp=$('[data-pp]');
if(pp){
  var list=N.filter(function(n){return n.handle!==cur});
  if(list.length){
    var cards=list.map(function(n){
      return '<a class="nw-card nw-card--s" href="'+n.url+'"><span class="nw-card__tag">Nouveau</span><span class="nw-card__num">'+esc(n.num)+'</span><span class="nw-card__puffs">jusqu’à '+esc(n.puffs)+' bouffées</span><b class="nw-card__name">'+esc(n.name)+'</b><span class="nw-card__meta">'+n.count+' goûts</span><span class="nw-card__price">'+money(n.price)+'<small>l’unité</small></span><span class="nw-card__cta">Goûter →</span></a>';
    }).join('');
    var head=isNew(cur)?'Les autres nouveautés':'Goûte les nouveautés';
    var strip='<div class="nstrip"><div class="nstrip__hd"><h2>🆕 '+head+'</h2><span>dès '+money(minPrice)+'</span></div><div class="nstrip__track">'+cards+'</div></div>';
    var up16='';
    if(B&&cur!=='boite-jnr-16k'&&cur!=='jnr-16k'){
      up16='<a class="up16" href="'+B.url+'"><span class="up16__n">🔥</span><div><b>Boîte de 10 JNR 16K à '+money(B.price)+'</b>'+money(Math.round(B.price/10))+' la pièce · au prix de la 42K · 2 boîtes = livraison offerte</div></a>';
    }
    var anchor=$('.upsell',pp)||$('.badges',pp);
    if(anchor)anchor.insertAdjacentHTML('afterend',up16+strip);
  }
}

/* ---- Panier : suggestion nouveautés ---- */
var busy=false;
function chip(n){
  return '<a class="cn" href="'+n.url+'"><span class="cn__num">'+esc(n.num)+'</span><span class="cn__name">'+esc(n.name.replace(/^(AL FAKHER|JNR)\s+/i,''))+'</span><span class="cn__price">'+money(n.price)+'</span></a>';
}
function build(c){
  if(!c.item_count)return '';
  var inCart=c.items.map(function(i){return i.handle});
  var list=N.filter(function(n){return inCart.indexOf(n.handle)<0});
  if(!list.length)return '';
  var p=Math.min.apply(null,list.map(function(n){return n.price}));
  var free=(window.JNR&&JNR.free)||12000;
  var left=Math.max(0,free-c.total_price);
  var tip=(left>0&&left<=p)?'<p class="cart__news-tip">🚚 +1 nouveauté = <b>livraison offerte</b></p>':'';
  return '<div class="cart__news" data-cart-news><b class="cart__news-t">🆕 Goûte les nouveautés <small>dès '+money(p)+'</small></b><div class="cart__news-track">'+list.map(chip).join('')+'</div>'+tip+'</div>';
}
function inject(root){
  var body=$('.cart__body',root);
  if(!body||$('[data-cart-news]',body)||!$('.li',body)||busy)return;
  busy=true;
  fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(c){
    var h=build(c);
    if(h&&body.isConnected&&!$('[data-cart-news]',body))body.insertAdjacentHTML('beforeend',h);
  }).catch(function(){}).then(function(){busy=false});
}
$$('[data-cart-root]').forEach(function(root){
  new MutationObserver(function(){inject(root)}).observe(root,{childList:true});
  inject(root);
});
})();
